import type { ReactNode } from 'react'

import { ConnectedButton } from '@/src/elements/button/connected'
import type { TDefaultButtonProps } from '@/src/elements/button/default'
import { ICON } from '@/src/general/enums/icons'

const startIcon = (isLoading: boolean) => (isLoading ? undefined : ICON.FIRE)
export const PrayButton = ({ ref, ...props }: TDefaultButtonProps & { label: ReactNode }) => (
  <ConnectedButton ref={ref} startIcon={startIcon(!!props.isLoading)} variant="solid" colors="primary" {...props}>
    {props.label}
  </ConnectedButton>
)
